<div class="row mt-5">
  <div class="col-12">
    <h2 id="shareClass">Categories d'action</h2>

    @for (shareClassForm of this.shareClasses.formGroups; track shareClassForm; let i = $index) {
      <div class="card">
        <div class="row card-body">
          <div class="row d-flex justify-content-between">
            <div class="d-flex" style="width: fit-content">
              <h3 [id]="'shares-category-' + (i + 1)">Categorie d'action #{{ i + 1 }}</h3>
            </div>
            <div class="dropdown d-flex" style="width: fit-content">
              <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
                data-expanded="false" href="#" role="button">
                <i class="fe fe-more-vertical"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end">
                <a (click)="removeShareClass(i); $event.preventDefault()" class="dropdown-item"
                  href="#">
                  Supprimer
                </a>
              </div>
            </div>
          </div>
          <app-rollover-share-class-form #shareClass [form]="this.form" [index]="i"
          [shareClassForm]="shareClassForm"></app-rollover-share-class-form>
        </div>
      </div>
    }

    <div class="card">
      <a (click)="this.addShareClass(); $event.preventDefault()" class="card-body" href="#shareClass"
        id="add_share_class">
        + Ajouter une categorie d'action
      </a>
    </div>

  </div>
</div>